export interface Faculty {
    CODE: string;
    TITLE: string;
    TYPE: string;
    CREDITS: string;
    VENUE: string;
    SLOT: string;
    FACULTY: string;
}

export const searchFaculty = (
    query: string,
    allFacultyData: Faculty[],
    courseNameDisplay: string,
    theoryCourseSlots: string[],
    alreadySelectedFaculty: string[]
): string[] => {
    const lowerCaseQuery = query.toLowerCase();
    const courseTitleToMatch = courseNameDisplay.toLowerCase();
    const sortedSlotsString = [...theoryCourseSlots].sort().join('+');

    const results = allFacultyData
        .filter(faculty => {
            const facultySlotsSorted = faculty.SLOT.split('+').sort().join('+');
            
            const courseMatch = faculty.TITLE.toLowerCase().includes(courseTitleToMatch);
            const slotMatch = facultySlotsSorted === sortedSlotsString;
            const nameMatch = faculty.FACULTY.toLowerCase().includes(lowerCaseQuery);
            const notAlreadySelected = !alreadySelectedFaculty.includes(faculty.FACULTY.toLowerCase());

            return courseMatch && slotMatch && nameMatch && notAlreadySelected;
        })
        .map(faculty => faculty.FACULTY);
    
    return Array.from(new Set(results));
}; 